import { IOdataField } from '../Field/IOdataField';

export class OdataSort {
  private field: IOdataField;
  private sortDirection: OdataSortDirection;

  constructor(field: IOdataField, sortDirection: OdataSortDirection) {
    this.field = field;
    this.sortDirection = sortDirection;
  }

  toSortString() {
    var direction: string;

    if (this.sortDirection === OdataSortDirection.Desc) {
      direction = "desc";
    } else {
      direction = "asc";
    }

    return `${this.field.toFieldString()} ${direction}`;
  }
}

export function convertStringToOdataSortDirection(input: string): OdataSortDirection {
  return input.toLocaleLowerCase() === "desc" ? OdataSortDirection.Desc : OdataSortDirection.Asc;
}

export enum OdataSortDirection {
  Asc = 1,
  Desc
}
